import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is cookie-only: HttpOnly `session_token` cookie set by the backend.
// withCredentials ensures the browser attaches it on every API call.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
